var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLogo)?_c('div',{staticClass:"dosearch-logo inner-x"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.algolia.com/docsearch","target":"_blank"}},[_c('img',{attrs:{"src":"https://www.algolia.com/static_assets/images/press/downloads/search-by-algolia.svg","alt":"algolia","width":"100"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a0758d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/docsearch/Logo.vue
// module id = 38
// module chunks = 0